import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase, get, includes, some, first } from 'lodash';
import $ from 'jquery';
import {
  Accordion,
  AccordionContent,
  AccordionGroup,
  AccordionHeader
} from 'core/controls';
import FeaturesCompareRow from './FeaturesCompareRow';

class FeaturesCompareTable extends React.Component {
  static defaultProps = {
    defaultSections: []
  };

  constructor(props) {
    super(props);

    const { defaultSections, featureGroups } = props;

    const possibleSections = Object.keys(featureGroups);
    const hasPossibleSections = some(defaultSections, x =>
      includes(possibleSections, x)
    );
    const sections = hasPossibleSections
      ? defaultSections
      : [...defaultSections, first(possibleSections)];

    this.state = {
      sections
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    const { defaultSections, onSectionsChange } = this.props;
    const { sections } = this.state;
    if (sections !== defaultSections) {
      setTimeout(() => {
        onSectionsChange(sections);
      });
    }
  }

  onToggle = group => {
    const { onSectionsChange } = this.props;
    const { sections } = this.state;
    const { description } = group;

    const isCollapsing = includes(sections, description);

    const updatedSections = isCollapsing
      ? sections.filter(x => x !== description)
      : [...sections, description];

    this.setState({ sections: updatedSections }, () => {
      onSectionsChange(updatedSections);
      if (!isCollapsing) {
        this.scrollToSection(group);
      }
    });
  };

  scrollToSection = group => {
    const { id } = group;
    const el = document.getElementById(id);

    $(this.ref.current).animate({ scrollTop: el.offsetTop }, 500);
  };

  render() {
    const { featureGroups, columns, analyticsKey } = this.props;
    const { sections } = this.state;

    const list = Object.keys(featureGroups).map(groupKey => {
      const group = featureGroups[groupKey];

      const features = Object.keys(group).map(featureKey => {
        const feature = group[featureKey];
        return {
          id: featureKey,
          ...feature,
          values: columns.map(x => get(x, [groupKey, featureKey]))
        };
      });

      return {
        id: kebabCase(groupKey),
        description: groupKey,
        features
      };
    });

    return (
      <div ref={this.ref} className="features-compare-content">
        <Accordion>
          {list.map(({ id, description, features }) => {
            return (
              <AccordionGroup
                key={id}
                id={id}
                isOpenDefault={includes(sections, description)}
                onToggle={() => this.onToggle({ id, description })}
                className="accordion-item--condensed">
                <AccordionHeader
                  className="features-compare-header__accordion-title"
                  analyticsKey={`${analyticsKey}:${description}`}>
                  {description}
                </AccordionHeader>
                <AccordionContent>
                  {features.map(feature => (
                    <FeaturesCompareRow
                      key={feature.id}
                      feature={feature}
                      analyticsKey={analyticsKey}
                    />
                  ))}
                </AccordionContent>
              </AccordionGroup>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

FeaturesCompareTable.propTypes = {
  featureGroups: PropTypes.object.isRequired,
  columns: PropTypes.array.isRequired,
  defaultSections: PropTypes.array,
  analyticsKey: PropTypes.string,
  onSectionsChange: PropTypes.func.isRequired
};

export default FeaturesCompareTable;
